var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbsDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1665 1.66797V10.8346M18.3332 8.16797V4.33464C18.3332 3.40121 18.3332 2.9345 18.1516 2.57798C17.9918 2.26438 17.7368 2.00941 17.4232 1.84962C17.0667 1.66797 16.6 1.66797 15.6665 1.66797H6.76489C5.54699 1.66797 4.93804 1.66797 4.4462 1.89083C4.01271 2.08725 3.6443 2.40332 3.38425 2.8019C3.08919 3.25413 2.99659 3.856 2.8114 5.05974L2.37551 7.89307C2.13125 9.48073 2.00912 10.2746 2.24472 10.8922C2.4515 11.4344 2.84042 11.8877 3.34482 12.1745C3.91949 12.5013 4.72266 12.5013 6.32899 12.5013H6.99988C7.46659 12.5013 7.69995 12.5013 7.87821 12.5921C8.03501 12.672 8.16249 12.7995 8.24239 12.9563C8.33321 13.1346 8.33321 13.3679 8.33321 13.8346V16.2798C8.33321 17.4146 9.25321 18.3346 10.3881 18.3346C10.6588 18.3346 10.9041 18.1752 11.014 17.9279L13.8146 11.6265C13.942 11.3398 14.0057 11.1965 14.1064 11.0915C14.1954 10.9986 14.3047 10.9276 14.4257 10.884C14.5626 10.8346 14.7194 10.8346 15.033 10.8346H15.6665C16.6 10.8346 17.0667 10.8346 17.4232 10.653C17.7368 10.4932 17.9918 10.2382 18.1516 9.92462C18.3332 9.5681 18.3332 9.10139 18.3332 8.16797Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsDown);
export default __webpack_public_path__ + "static/media/thumbs-down.65a1cf70e2c17e424500793183cc6fba.svg";
export { ForwardRef as ReactComponent };